import { Avatar } from '@/components';
import { useAuth } from '@/features/auth/AuthProvider';
import { cn } from '@/lib/cn';
import { type JSX, Show, createSignal } from 'solid-js';
import { AccountMenu } from './AccountMenu';

export const UserPanel = (props: { collapsed: boolean }): JSX.Element => {
  const { session, firebaseUser } = useAuth();
  const [open, setOpen] = createSignal(false);
  const s = () => session();

  return (
    <div class="relative">
      <Show when={s()} fallback={<div class="p-3 text-xs text-neutral-500">Not signed in</div>}>
        {(value) => (
          <>
            <button
              type="button"
              class={cn(
                'flex w-full items-center gap-3 px-3 py-3 text-left text-sm transition-colors',
                'hover:bg-neutral-100 dark:hover:bg-neutral-800',
              )}
              onClick={() => setOpen((o) => !o)}
              aria-expanded={open()}
            >
              <Avatar
                user={{
                  displayName: value().displayName,
                  email: value().email,
                  // Same precedence as UserRef payloads: Firebase photo → GitHub → initials.
                  avatarUrl: firebaseUser()?.photoURL ?? value().githubAvatarUrl,
                }}
                class="h-8 w-8 text-xs"
              />
              <Show when={!props.collapsed}>
                <div class="flex min-w-0 flex-1 flex-col">
                  <span class="truncate font-medium">{value().displayName || value().email}</span>
                  <span class="truncate text-xs text-neutral-500">
                    {value()
                      .roles.map((r) => r.name)
                      .join(', ')}
                  </span>
                </div>
              </Show>
            </button>
            <Show when={open()}>
              <AccountMenu onClose={() => setOpen(false)} />
            </Show>
          </>
        )}
      </Show>
    </div>
  );
};
